/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    PaymentTypesStatDto,
    RegistryItemsCountDto,
    TurnoversByActivitiesByCategories,
} from '../api/dashBoard/dashBoardClient.typings';
import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';
import { FinChartType } from '../../components/DashboardWitgets/Common/ChartsTyping';

export enum DashBoardFinActionType {
    OPEN_DASHBOARD_FIN_PAGE = 'DashBoardFin/ open page',
    EXIT_DASHBOARD_FIN_PAGE = 'DashBoardFin/ exit page',

    FETCH_PAYMENT_TYPES_SUCCESS = 'DashBoardFin/ fetch payment types stat success',
    FETCH_TURNOVERS_BY_ACTIVITIES_SUCCESS = 'DashBoardFin/ fetch turnovers by activities success',
    FETCH_REGISTRY_ITEMS_COUNT_INFO_SUCCESS = 'DashBoardFin/ fetch registry items data success',

    FETCH_PAYMENT_TYPES_ERROR = 'DashBoardFin/ fetch payment types stat error',
    FETCH_TURNOVERS_BY_ACTIVITIES_ERROR = 'DashBoardFin/ fetch turnovers by activities error',
    FETCH_REGISTRY_ITEMS_COUNT_INFO_ERROR = 'DashBoardFin/ fetch registry items data error',

    DOWNLOAD_EXCEL = 'DashBoardFin/ download data as excel',
    DOWNLOAD_EXCEL_SUCCESS = 'DashBoardFin/ download data as excel success',
    DOWNLOAD_EXCEL_ERROR = 'DashBoardFin/ download data as excel error',
}

export const openDashBoardFinPage = () => createAction(DashBoardFinActionType.OPEN_DASHBOARD_FIN_PAGE);

export const fetchPaymentTypesSuccessAction = (data: PaymentTypesStatDto[]) =>
    createAction(DashBoardFinActionType.FETCH_PAYMENT_TYPES_SUCCESS, data);

export const fetchTurnoversByActivitiesSuccessAction = (data: TurnoversByActivitiesByCategories) =>
    createAction(DashBoardFinActionType.FETCH_TURNOVERS_BY_ACTIVITIES_SUCCESS, data);

export const fetchRegistryItemsCountSuccessAction = (data: RegistryItemsCountDto) =>
    createAction(DashBoardFinActionType.FETCH_REGISTRY_ITEMS_COUNT_INFO_SUCCESS, data);

export const exitDashBoardFinPage = () => createAction(DashBoardFinActionType.EXIT_DASHBOARD_FIN_PAGE);

export const fetchPaymentTypesErrorAction = (notification: Notification) =>
    createAction(DashBoardFinActionType.FETCH_PAYMENT_TYPES_ERROR, { notification });

export const fetchTurnoversByActivitiesErrorAction = (notification: Notification) =>
    createAction(DashBoardFinActionType.FETCH_TURNOVERS_BY_ACTIVITIES_ERROR, { notification });

export const fetchRegistryItemsCountErrorAction = (notification: Notification) =>
    createAction(DashBoardFinActionType.FETCH_REGISTRY_ITEMS_COUNT_INFO_ERROR, { notification });

export const downloadFinChartDataAsExcelAction = <T>(dataType: FinChartType, params?: T) =>
    createAction(DashBoardFinActionType.DOWNLOAD_EXCEL, { dataType, params });

export const downloadFinChartDataAsExcelSuccessAction = (dataType: FinChartType) =>
    createAction(DashBoardFinActionType.DOWNLOAD_EXCEL_SUCCESS, dataType);

export const downloadFinChartDataAsExcelErrorAction = (notification: Notification, dataType: FinChartType) =>
    createAction(DashBoardFinActionType.DOWNLOAD_EXCEL_ERROR, { notification, dataType });

export type DashBoardFinAction =
    | ReturnType<typeof openDashBoardFinPage>
    | ReturnType<typeof exitDashBoardFinPage>
    | ReturnType<typeof fetchPaymentTypesSuccessAction>
    | ReturnType<typeof fetchTurnoversByActivitiesSuccessAction>
    | ReturnType<typeof fetchRegistryItemsCountSuccessAction>
    | ReturnType<typeof fetchPaymentTypesErrorAction>
    | ReturnType<typeof fetchTurnoversByActivitiesErrorAction>
    | ReturnType<typeof fetchRegistryItemsCountErrorAction>
    | ReturnType<typeof downloadFinChartDataAsExcelAction>
    | ReturnType<typeof downloadFinChartDataAsExcelSuccessAction>
    | ReturnType<typeof downloadFinChartDataAsExcelErrorAction>;
